import Grid from "@material-ui/core/Grid";
import School from "@material-ui/icons/School";
import React, { FC } from "react";
import TitleWithIcon from "../../common/TitleWithIcon";
import TranslatedMessage from "../../translations/TranslatedMessage";

const ExamSessionCandidateListHeader: FC = () => (
  <Grid container={true} spacing={0} alignItems="baseline">
    <Grid item={true} xs={12} sm={6}>
      <TitleWithIcon title={<TranslatedMessage id="candidate.header" />} variant="h5">
        <School fontSize="small" />
      </TitleWithIcon>
    </Grid>
    <Grid item={true} xs={12} sm={6}></Grid>
  </Grid>
);

export default ExamSessionCandidateListHeader;
